import doneIconWhite from "assets/icons/doneIconWhite.svg";
import styled from "styled-components";

const Wrapper = styled.div`
  label {
    margin-left: 1.2rem;
    cursor: pointer;
  }
`;

const Box = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ffffff;
  height: 2.4rem;
  width: 2.4rem;
  border: 1px solid
    ${(props) =>
      // @ts-ignore
      props.checked ? "var(--secondary)" : "#cccccc"};
  border-radius: ${(props) =>
    // @ts-ignore
    props.circle ? "100%" : "4px"};
  background-color: ${(props) =>
    // @ts-ignore
    props.checked ? "var(--secondary)" : "transparent"};
  cursor: pointer;

  input {
    display: none;
  }

  .checkedIcon {
    height: 100%;
    pointer-events: none;
  }
`;

/**
 *
 * @param {Object} props
 * @param {string} props.id id for react performance
 * @param {string} [props.className] preferred style for component
 * @param {string} [props.name]
 * @param {string} [props.grey]
 * @param {string} [props.circle]
 * @param {string} [props.label]
 * @param {Function | any} [props.onClick]
 * @param {boolean} [props.checked]
 *
 * @returns
 */

const ControlledCheckBox = ({
  id,
  className,
  name,
  grey,
  circle,
  label,
  onClick,
  checked = false,
  ...props
}) => {
  return (
    <Wrapper className="flexRow alignCenter checkBox">
      <Box
        grey={grey}
        circle={circle}
        checked={checked}
        onClick={(e) => onClick?.(e)}
        className={className}
        {...props}
      >
        <img src={doneIconWhite} alt="check" className="checkedIcon" />
      </Box>
      {label && (
        <label htmlFor={`${id}`} className="l3 ellipsify">
          {label}
        </label>
      )}
    </Wrapper>
  );
};

export default ControlledCheckBox;
